import { Helmet } from 'react-helmet-async';
import React from 'react';

import requireAuth from '../../../../lib/requireAuth.jsx';
import withRouterParams from '../../../../lib/withRouterParams.jsx';

import OrgCustomStatusesSettingsFormContainer from '../../../../containers/organizations/Settings/OrgCustomStatusesFormContainer.jsx';

const CustomStatusesSettings = ({ projectId, slug }) => (
  <>
    <Helmet>
      <title>Change Strategy Settings | ChangeSync</title>
    </Helmet>
    <OrgCustomStatusesSettingsFormContainer slug={slug} projectId={projectId} />
  </>
);

CustomStatusesSettings.getInitialProps = ({ query }) => ({
  slug: query.slug,
  projectId: Number(query.projectId),
});

export default requireAuth(withRouterParams(CustomStatusesSettings));
